import { render } from "./raceDivideManager.vue?vue&type=template&id=5951141c&scoped=true"
import script from "./raceDivideManager.vue?vue&type=script&lang=js"
export * from "./raceDivideManager.vue?vue&type=script&lang=js"

import "./raceDivideManager.vue?vue&type=style&index=0&id=5951141c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5951141c"]])

export default __exports__